import Boss from "../animations/bosses/Boss";
import BossDragon from "../animations/bosses/BossDragon";
import BossHobgoblin from "../animations/bosses/BossHobgoblin";
import BossMage from "../animations/bosses/BossMage";
import BossSpider from "../animations/bosses/BossSpider";
import BossSpirit from "../animations/bosses/BossSpirit";
import BossTrainingTroll from "../animations/bosses/BossTrainingTroll";
import BossTroll from "../animations/bosses/BossTroll";
import Guardian from "../animations/guardians/Guardian";
import GuardianElf from "../animations/guardians/GuardianElf";
import GuardianElfFemale from "../animations/guardians/GuardianElfFemale";
import GuardianKnight from "../animations/guardians/GuardianKnight";
import GuardianKnightFemale from "../animations/guardians/GuardianKnightFemale";
import GuardianRanger from "../animations/guardians/GuardianRanger";
import GuardianRangerFemale from "../animations/guardians/GuardianRangerFemale";
import GuardianWarrior from "../animations/guardians/GuardianWarrior";
import GuardianWitch from "../animations/guardians/GuardianWitch";
import GuardianWizard from "../animations/guardians/GuardianWizard";
import Pet from "../animations/pets/Pet";
import PetBat from "../animations/pets/PetBat";
import PetDragon from "../animations/pets/PetDragon";
import PetOwl from "../animations/pets/PetOwl";
import PetRaven from "../animations/pets/PetRaven";
import common from "../common";
import QuestionFactory from "../maths/QuestionFactory";
import GelButton from "../ui/gel/GelButton";
import GelScene from "../ui/gel/GelScene";
import HealthBar from "../ui/HealthBar";
import QuestionInput from "../ui/input/QuestionInput";
import QuestionInputKeypad from "../ui/input/QuestionInputKeypad";
import QuestionInputSelect from "../ui/input/QuestionInputSelect";
import QuestionInputSelectClockFace from "../ui/input/QuestionInputSelectClockFace";
import QuestionInputSelectMulti from "../ui/input/QuestionInputSelectMulti";
import QuestionInputSelectMultiEquivalents from "../ui/input/QuestionInputSelectMultiEquivalents";
import QuestionInputSelectMultiSum from "../ui/input/QuestionInputSelectMultiSum";
import QuestionInputSelectMultiGraph from "../ui/input/QuestionInputSelectMultiGraph";
import QuestionInputSelectMultiVisual from "../ui/input/QuestionInputSelectMultiVisual";
import QuestionInputSelectMultiVisualEquivalents from "../ui/input/QuestionInputSelectMultiVisualEquivalents";
import QuestionInputSelectSum from "../ui/input/QuestionInputSelectSum";
import QuestionInputSelectTime from "../ui/input/QuestionInputSelectTime";
import QuestionInputSelectVisual from "../ui/input/QuestionInputSelectVisual";
import QuestionInputSort from "../ui/input/QuestionInputSort";
import QuestionInputSortConversion from "../ui/input/QuestionInputSortConversion";
import QuestionCounter from "../ui/QuestionCounter";
import QuizTimer from "../ui/QuizTimer";
import QuestionView from "../ui/view/QuestionView";
import QuestionViewBoolean from "../ui/view/QuestionViewBoolean";
import QuestionViewComparison from "../ui/view/QuestionViewComparison";
import QuestionViewGraphBar from "../ui/view/QuestionViewGraphBar";
import QuestionViewGraphTally from "../ui/view/QuestionViewGraphTally";
import QuestionViewGraphVen from "../ui/view/QuestionViewGraphVen";
import QuestionViewRotatedShape from "../ui/view/QuestionViewRotatedShape";
import QuestionViewSequence from "../ui/view/QuestionViewSequence";
import QuestionViewSort from "../ui/view/QuestionViewSort";
import QuestionViewStatement from "../ui/view/QuestionViewStatement";
import QuestionViewStatementAlgebra from "../ui/view/QuestionViewStatementAlgebra";
import QuestionViewStatementAlgebraPair from "../ui/view/QuestionViewStatementAlgebraPair";
import QuestionViewStatementFraction from "../ui/view/QuestionViewStatementFraction";
import QuestionViewStatementLong from "../ui/view/QuestionViewStatementLong";
import QuestionViewStatementMulti from "../ui/view/QuestionViewStatementMulti";
import QuestionViewVerbal from "../ui/view/QuestionViewVerbal";
import QuestionViewVerbalAngle from "../ui/view/QuestionViewVerbalAngle";
import QuestionViewVerbalClockFace from "../ui/view/QuestionViewVerbalClockFace";
import QuestionViewVerbalCompose from "../ui/view/QuestionViewVerbalCompose";
import QuestionViewVerbalConversion from "../ui/view/QuestionViewVerbalConversion";
import QuestionViewVerbalEquivalent from "../ui/view/QuestionViewVerbalEquivalent";
import QuestionViewVerbalExponent from "../ui/view/QuestionViewVerbalExponent";
import QuestionViewVerbalFindRest from "../ui/view/QuestionViewVerbalFindRest";
import QuestionViewVerbalMultiples from "../ui/view/QuestionViewVerbalMultiples";
import QuestionViewVerbalRatio from "../ui/view/QuestionViewVerbalRatio";
import QuestionViewVerbalRound from "../ui/view/QuestionViewVerbalRound";
import QuestionViewVerbalShape from "../ui/view/QuestionViewVerbalShape";
import QuestionViewVerbalStatic from "../ui/view/QuestionViewVerbalStatic";
import QuestionViewVerbalStats from "../ui/view/QuestionViewVerbalStats";
import QuestionViewVerbalSum from "../ui/view/QuestionViewVerbalSum";
import QuestionViewVerbalTime from "../ui/view/QuestionViewVerbalTime";
import QuestionViewVerbalValue from "../ui/view/QuestionViewVerbalValue";
import QuestionViewVerbalVolume from "../ui/view/QuestionViewVerbalVolume";
import QuestionViewVisual from "../ui/view/QuestionViewVisual";
import QuestionViewVisualEquivalent from "../ui/view/QuestionViewVisualEquivalent";
import QuestionViewVisualLiquid from "../ui/view/QuestionViewVisualLiquid";
import QuestionViewVisualShape from "../ui/view/QuestionViewVisualShape";
import QuestionViewVisualTime from "../ui/view/QuestionViewVisualTime";
import Achievement from "../Achievement";
import getParameter from "get-parameter";
import BossGoldenDragon from "../animations/bosses/BossGoldenDragon";
import {isFossil, isIE11, isIE11Win10} from "../utils";

export default class GameScene extends GelScene {
    constructor() {
        super();

        this._camera = null;
        this._cameraTweens = new P3.utils.TWEEN.Group();

        this._backgroundLayer = null;
        this._midgroundLayer = null;
        this._gameLayer = null;
        this._particleLayer = null;
        this._hudLayer = null;

        this._totalXp = 0;
        this._correctCount = 0;

        this._questions = [];
        this._questionCount = Math.min(10, common.config.game.question_count);
        this._questionIndex = 0;
        this._questionView = null;
        this._questionInput = null;

        this._answers = [];

        this._partyHealth = 0;
        this._bossHealth = 0;

        this._party = [];
        this._partyCount = 0;

        this._boss = null;
        this._pet = null;

        this._partyHealthBar = null;
        this._bossHealthBar = null;
        this._questionCounter = null;
        this._timer = null;
        this._questionHolder = null;
        this._xpPanel = null;

        this._running = false;

        this._defaultMusicName = P3.utils.selectRandom(["music_battle_loop_01", "music_battle_loop_02", "music_battle_loop_03"]);
        this._dangerMusicName = P3.utils.selectRandom(["music_timed_battle_01", "music_timed_battle_02", "music_timed_battle_03"]);


        this._ambienceAudio = null;
        this._challengeAmbienceAudio = null;
        this._challengeAmbienceTween = null;

        this._bossIntroFinished = false;

        this._timePerQuestionStart = 0;
        this._timePerQuestion = 0;
        this._timePerQuestionFired = false;
        this._timePerQuestionEnabled = false;
        this._timePerQuestionDelay = 0;
        this._timePerQuestionDelayFired = false;

        this._timerLoopSFX = null;
    }

    init() {
        super.init();

        this._camera = new P3.NewCamera(new PIXI.Point(common.STAGE_WIDTH * 0.5, P3.View.height * 0.5), new PIXI.Point());

        this._backgroundLayer = new PIXI.Container();
        this.addChild(this._backgroundLayer);

        this._midgroundLayer = new PIXI.Container();
        this.addChild(this._midgroundLayer);

        this._gameLayer = new PIXI.Container();
        this.addChild(this._gameLayer);

        this._hudLayer = new PIXI.Container();
        this.addChild(this._hudLayer);

        this._camera.addLayer(new P3.CameraLayer(this._backgroundLayer, new PIXI.Point(0.2, 1)));
        this._camera.addLayer(new P3.CameraLayer(this._midgroundLayer, new PIXI.Point(0.6, 1)));
        this._camera.addLayer(new P3.CameraLayer(this._gameLayer, new PIXI.Point(1, 1)));

        this._partyHealth = this._questionCount;
        this._bossHealth = this._questionCount;

        this.generateQuestions();

        this.createScene();

        this._particleLayer = new PIXI.Container();
        this._gameLayer.addChild(this._particleLayer);

        this.initParty(common.STAGE_WIDTH * 0.5 - 380, 600);
        this.initBoss(common.STAGE_WIDTH * 0.5 + 440, 580);

        this.createUI();

        this.initPauseButton(GelButton.TAB_INDEX_LEVEL_0 + 1);

        if (!PIXI.utils.isMobile.any) {
            this.initCalculatorButton(GelButton.TAB_INDEX_LEVEL_0);

            const user = common.save.getUserData(common.userId);
            this._calculatorButton.toggle = user.showKeypad;
        }

        //Per question timing.
        this._timePerQuestionEnabled = common.location.timed_per_question;
        //this._timePerQuestionDelay = isIE11Win10() ? common.config.game.time_per_question_delay : 1000;

        this.start();

        // stats
        if (common.location.id === "tutorial") {
            common.gmi.setStatsScreen && common.gmi.setStatsScreen("training");
        } else {
            common.gmi.setStatsScreen && common.gmi.setStatsScreen(common.locationIndex + "");
        }

        // tracking
        common.gmi.sendStatsEvent("level", "start", {
            metadata: "LVL=" + common.location.id + "-" + (common.difficulty.level + 1)
        });
    }

    destroy() {
        this.stopAmbienceSFX();
        this.stopTimerLoopSFX();

        // clean up goes here
        super.destroy();
    }

    resize() {
        super.resize();

        this._xpPanel.position.set(
            common.STAGE_WIDTH * 0.5 - 440,
            80
        );
    }

    show() {
        super.show();

        this.setAllButtonsEnabled(true);

        this.playMusic();
        this.playAmbienceSFX();

        if (this._timerLoopSFX) {
            this._timerLoopSFX.howl.volume(1);
        }

        this._questionInput && this._questionInput.setInteractive(true);
        this._questionView && (this._questionView.confirmButton.interactive = true);

        const settings = common.gmi.getAllSettings();
        !settings.motion && this.disableMotionFX();

        //common.view.resize();
    }

    hide() {
        super.hide();

        this._questionInput && this._questionInput.setInteractive(false);
        this._questionView && (this._questionView.confirmButton.interactive = false);

        this.stopAmbienceSFX();

        if (this._timerLoopSFX) {
            this._timerLoopSFX.howl.volume(0);
        }

        P3.audio.stopVO();
    }

    appear() {
        super.appear();

        if (this._boss) {
            this._boss.playEnterAnim();
            P3.utils.delayg(this._tweens, 0, () => {
                this._boss.visible = true;
            });

            const bossVO = this._boss.playTauntVO();

            if (!(isIE11() || isIE11Win10()))
            {
                bossVO.signals.end.once(() =>
                {
                    this._timer.start();
                    this._bossIntroFinished = true;
                });
            }
            else
            {
                this._timer.start();
            }
        } else {
            console.log("boss no initialised - expected:", common.boss.type, common.boss);
        }
        this._questionCounter.animateIn(false);

        if (common.location.challenge)
        {
            common.achievements.unlock(Achievement.FACE_THE_GOLDEN_DRAGON);
        }
    }

    update() {
        super.update();

        const dt = window.dt;

        this._camera.update(dt);
        this._cameraTweens.update();

        const settings = common.gmi.getAllSettings();
        if (settings.motion) {
            for (let i = 0; i < this._party.length; ++i)
                this._party[i].update(dt);

            this._boss.update(dt);
            this._pet && this._pet.update(dt);
        }

        this._partyHealthBar.update(dt);
        this._bossHealthBar.update(dt);

        this._questionInput && this._questionInput.update(dt);
        this._questionView && this._questionView.update(dt);
        this._questionCounter.update(dt);
        this._timer.update(dt);

        if (this._timePerQuestionEnabled)
        {
            if (this._questionIndex === 0)
            {
                if (this._bossIntroFinished)
                {
                    this._timePerQuestionDelay -= dt * 1000;

                    if (this._timePerQuestionDelay <= 0)
                    {
                        if (!this._timePerQuestionDelayFired) {
                            this._timePerQuestionDelayFired = true;
                            this.startTimerLoopSFX();
                        }

                        this.updateTimerButton(dt);
                    }
                }
            } else {
                if (!this._timePerQuestionDelayFired) {
                    this._timePerQuestionDelayFired = true;
                    this.startTimerLoopSFX();
                }

                this.updateTimerButton(dt);
            }
        }
    }

    updateTimerButton(dt)
    {
        if (!this._timePerQuestionFired)
        {
            this._timePerQuestion -= dt * 1000;

            const t = 1 - (this._timePerQuestion / this._timePerQuestionStart);
            this._questionView.confirmButton.setTimerAmount(t);

            if (this._timePerQuestion <= 0) {
                this._timePerQuestionFired = true;

                this.stopTimerLoopSFX();

                this._questionView.confirmButton.enabledSwapStates = true;
                this._questionView.confirmButton.enabled = false;
                this._questionView.confirmButton.setTimerAmount(0);

                this.onQuestionViewConfirm(this._questionView, false);
            }
        }
    }

    start() {
        this._running = true;

        this.initQuestion();
    }

    end() {
        this._running = false;

        let success = this._bossHealth < this._partyHealth;
        if (success) {
            for (let i = 0; i < this._party.length; ++i) {
                const member = this._party[i];
                member.playVictoryAnim();
            }
            this._pet && this._pet.playVictoryAnim();
            this._boss.playDefeatAnim();

            P3.audio.playSound("music_round_won");
        } else {
            for (let i = 0; i < this._party.length; ++i) {
                const member = this._party[i];
                member.playDefeatAnim();
            }
            this._pet && this._pet.playDefeatAnim();
            this._boss.playVictoryAnim();
            P3.audio.playSound("music_round_lost");
        }

        const victory = this._bossHealth < this._partyHealth;
        let delay = 1.4;

        /*
        if (common.location.challenge && victory)
        {
            if (!common.save.isWeeklyChallengeComplete(common.userId))
            {
                P3.audio.playVO("vo_queen_extra_09b1", 1, true);
                delay = 4.5;
            }
        }
        */

        const xp = getParameter("extraXp");
        if (xp !== "")
        {
            this._totalXp = 100;
        }

        P3.utils.delayg(this._tweens, delay, () => {
            this.signals.next.dispatch(this, this._correctCount, this._questionCount, this._totalXp, victory, this._answers);
        });

        // tracking
        common.gmi.sendStatsEvent("level", "complete", {
            metadata:
                "LVL=" + common.location.id + "-" + (common.difficulty.level + 1) +
                "~LVR=" + (success ? "Success" : "Failure") +
                "~SCO=" + this._correctCount
        });

        console.log("game ended");
    }

    generateQuestions() {
        let seed = getParameter("seed");
        if (common.location.challenge)
        {
            if (seed === "")
            {
                const week = P3.math.clamp(common.week - 1, 1, 52);

                const seeds = common.config.game.weekly_challenge_seeds;

                seed = seeds[week];

                console.warn("seed:", seed, "week:", week, "forced:", getParameter("forceWeek") !== "");
            }
        }

        const factory = new QuestionFactory(common.location.modules, common.difficulty.level, seed);

        for (let i = 0; i < this._questionCount; ++i)
        {
            if (common.location.challenge)
            {
                const index = this._questions.length;
                this._questions.push(factory.createQuestionWithSeed(index));
            }
            else
            {
                this._questions.push(factory.createQuestion());
            }
        }
    }

    initQuestion(index) {
        this._questionView && this._questionView.destroy();
        this._questionInput && this._questionInput.destroy();

        index = typeof index === "undefined" ? this._questionIndex : index;
        const question = this._questions[index];
        console.log(question);

        switch (question.view) {
            default                                         : console.warn("unknown question view : " + question.view);             break;
            case QuestionView.STATIC_VERBAL                 : {this._questionView = new QuestionViewVerbalStatic(question);         break;}
            case QuestionView.VIEW_STATEMENT                : {this._questionView = new QuestionViewStatement(question);            break;}
            case QuestionView.VIEW_STATEMENT_MULTI          : {this._questionView = new QuestionViewStatementMulti(question);       break;}
            case QuestionView.VIEW_STATEMENT_LONG           : {this._questionView = new QuestionViewStatementLong(question);        break;}
            case QuestionView.VIEW_STATEMENT_FRACTION       : {this._questionView = new QuestionViewStatementFraction(question);    break;}
            case QuestionView.VIEW_STATEMENT_ALGEBRA        : {this._questionView = new QuestionViewStatementAlgebra(question);     break;}
            case QuestionView.VIEW_STATEMENT_ALGEBRA_PAIR   : {this._questionView = new QuestionViewStatementAlgebraPair(question); break;}
            case QuestionView.VIEW_VERBAL                   : {this._questionView = new QuestionViewVerbal(question);               break;}
            case QuestionView.VIEW_VERBAL_VOLUME            : {this._questionView = new QuestionViewVerbalVolume(question);         break;}
            case QuestionView.VIEW_VERBAL_BOOLEAN           : {this._questionView = new QuestionViewBoolean(question);              break;}
            case QuestionView.VIEW_VERBAL_EXPONENT          : {this._questionView = new QuestionViewVerbalExponent(question);       break;}
            case QuestionView.VIEW_VERBAL_ROUND             : {this._questionView = new QuestionViewVerbalRound(question);          break;}
            case QuestionView.VIEW_VERBAL_STATS             : {this._questionView = new QuestionViewVerbalStats(question) ;         break;}
            case QuestionView.VIEW_SORT                     : {this._questionView = new QuestionViewSort(question);                 break;}
            case QuestionView.VIEW_VISUAL                   : {this._questionView = new QuestionViewVisual(question);               break;}
            case QuestionView.VIEW_VISUAL_TIME              : {this._questionView = new QuestionViewVisualTime(question);           break;}
            case QuestionView.VIEW_VISUAL_CLOCK_FACE        : {this._questionView = new QuestionViewVerbalClockFace(question);      break;}
            case QuestionView.VIEW_VISUAL_LIQUID            : {this._questionView = new QuestionViewVisualLiquid(question);         break;}
            case QuestionView.VIEW_VISUAL_ROTATED_SHAPE     : {this._questionView = new QuestionViewRotatedShape(question);         break;}
            case QuestionView.VIEW_COMPARISON               : {this._questionView = new QuestionViewComparison(question);           break;}
            case QuestionView.VIEW_SEQUENCE                 : {this._questionView = new QuestionViewSequence(question);             break;}
            case QuestionView.VIEW_VERBAL_SHAPE             : {this._questionView = new QuestionViewVerbalShape(question);          break;}
            case QuestionView.VIEW_VERBAL_EQUIVALENT        : {this._questionView = new QuestionViewVerbalEquivalent(question);     break;}
            case QuestionView.VIEW_VERBAL_RATIO             : {this._questionView = new QuestionViewVerbalRatio(question);          break;}
            case QuestionView.VIEW_VERBAL_VALUE             : {this._questionView = new QuestionViewVerbalValue(question);          break;}
            case QuestionView.VIEW_VERBAL_COMPOSE           : {this._questionView = new QuestionViewVerbalCompose(question);        break;}
            case QuestionView.VIEW_VERBAL_MULTIPLES         : {this._questionView = new QuestionViewVerbalMultiples(question);      break;}
            case QuestionView.VIEW_VERBAL_TIME              : {this._questionView = new QuestionViewVerbalTime(question);           break;}
            case QuestionView.VIEW_VERBAL_CONVERSION        : {this._questionView = new QuestionViewVerbalConversion(question);     break;}
            case QuestionView.VIEW_VERBAL_REST              : {this._questionView = new QuestionViewVerbalFindRest(question);       break;}
            case QuestionView.VIEW_VERBAL_SUM               : {this._questionView = new QuestionViewVerbalSum(question);            break;}
            case QuestionView.VIEW_VERBAL_ANGLE             : {this._questionView = new QuestionViewVerbalAngle(question);          break;}
            case QuestionView.VIEW_GRAPH_VEN                : {this._questionView = new QuestionViewGraphVen(question);             break;}
            case QuestionView.VIEW_GRAPH_BAR                : {this._questionView = new QuestionViewGraphBar(question);             break;}
            case QuestionView.VIEW_GRAPH_TALLY              : {this._questionView = new QuestionViewGraphTally(question);           break;}
            case QuestionView.VIEW_VISUAL_EQUIVALENT        : {this._questionView = new QuestionViewVisualEquivalent(question);     break;}
            case QuestionView.VIEW_VISUAL_SHAPE             : {this._questionView = new QuestionViewVisualShape(question);          break;}
        }

        this._questionView.position.set(common.STAGE_WIDTH * 0.5, 0);
        this._questionView.signals.confirm.add(this.onQuestionViewConfirm, this);
        this._questionHolder.addChild(this._questionView);

        this._questionView.header.y = this._questionView.header.height * 0.5 + 20;
        this._questionView.footer.y = P3.View.height - this._questionView.footerHeight * 0.5 - 60;

        /*static question input select*/
        if(Array.isArray(question.input)){
            question._input = P3.utils.selectRandom(question.input)
        }

        switch (question.input) {
            default :
            case QuestionInput.INPUT_SELECT : {
                this._questionInput = new QuestionInputSelect(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5,
                    this._questionView.y + this._questionView.footer.y - this._questionView.footerHeight * 0.5 - 36);
                break;
            }
            case QuestionInput.INPUT_SELECT_SUM : {
                this._questionInput = new QuestionInputSelectSum(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5,
                    this._questionView.y + this._questionView.footer.y - this._questionView.footerHeight * 0.5 - 36);
                break;
            }
            case QuestionInput.INPUT_SELECT_TIME : {
                this._questionInput = new QuestionInputSelectTime(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5,
                    this._questionView.y + this._questionView.footer.y - this._questionView.footerHeight * 0.5 - 36);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI : {
                this._questionInput = new QuestionInputSelectMulti(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI_SUM : {
                this._questionInput = new QuestionInputSelectMultiSum(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI_VISUAL : {
                this._questionInput = new QuestionInputSelectMultiVisual(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI_EQUIVALENT : {
                this._questionInput = new QuestionInputSelectMultiEquivalents(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y - 100);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI_GRAPH : {
                this._questionInput = new QuestionInputSelectMultiGraph(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y - 100);
                break;
            }
            case QuestionInput.INPUT_SELECT_VISUAL : {
                this._questionInput = new QuestionInputSelectVisual(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SELECT_CLOCK_FACE : {
                this._questionInput = new QuestionInputSelectClockFace(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_KEYPAD : {
                this._questionInput = new QuestionInputKeypad(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5,
                    this._questionView.y + this._questionView.footer.y - this._questionView.footer.height * 0.5 - 20);
                break;
            }
            case QuestionInput.INPUT_KEYPAD_RIGHT : {
                this._questionInput = new QuestionInputKeypad(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5 + 250,
                    this._questionView.y + this._questionView.footer.y - this._questionView.footer.height * 0.5 - 20);
                break;
            }
            case QuestionInput.INPUT_SORT : {
                this._questionInput = new QuestionInputSort(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SORT_CONVERSION : {
                this._questionInput = new QuestionInputSortConversion(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y);
                break;
            }
            case QuestionInput.INPUT_SELECT_MULTI_VISUAL_EQUIVALENT : {
                this._questionInput = new QuestionInputSelectMultiVisualEquivalents(question, this._questionView);
                this._questionInput.position.set(common.STAGE_WIDTH * 0.5, this._questionView.y + this._questionView.footer.y - 100);
                break;
            }
        }

        this._questionInput.init();
        this._questionHolder.addChild(this._questionInput);

        //do some final hard coded visual adjustments for special cases
        switch (question.view) {
            case QuestionView.VIEW_STATEMENT_LONG: {
                this._questionView.footer.y = P3.View.height * 0.5;
                this._questionView.confirmButton.y = 255;
                this._questionInput.y = 635;
                break;
            }
            case QuestionView.VIEW_STATEMENT_ALGEBRA: {
                this._questionView.footer.y = P3.View.height - this._questionView.footerHeight * 0.5 - 120;
                if (question.input !== QuestionInput.INPUT_KEYPAD) this._questionInput.y = this._questionView.y + this._questionView.footer.y - this._questionView.footerHeight * 0.5 - 36;
                else this._questionInput.y = this._questionView.y + this._questionView.footer.y - this._questionView.footerHeight * 0.5 - 26;
                this._questionView.setInputFieldHeight(100);
                break;
            }
            case QuestionView.VIEW_STATEMENT_ALGEBRA_PAIR: {
                this._questionView.footer.y = P3.View.height - this._questionView.footerHeight * 0.5 - 170;
                if (question.input !== QuestionInput.INPUT_KEYPAD) this._questionInput.y = this._questionView.y + this._questionView.footer.y - this._questionView.footerHeight * 0.5 + 10;
                this._questionView.setInputFieldHeight(100);
                break;
            }
        }

        switch (question.input) {
            case QuestionInput.INPUT_SELECT_MULTI_VISUAL_EQUIVALENT:
            case QuestionInput.INPUT_SELECT_MULTI_VISUAL:
            case QuestionInput.INPUT_SELECT_MULTI_EQUIVALENT:
            case QuestionInput.INPUT_SELECT_MULTI_SUM:
            case QuestionInput.INPUT_SELECT_MULTI:
            case QuestionInput.INPUT_SELECT_MULTI_GRAPH: {
                this._questionInput.y = this._questionView.footer.y;
                break;
            }
        }

        //Timed per question.
        if (this._timePerQuestionEnabled) {
            this._timePerQuestionStart = common.config.game.time_per_question[common.difficulty.level];
            this._timePerQuestion = this._timePerQuestionStart;
            this._timePerQuestionDelay = (isIE11() || isIE11Win10()) ? common.config.game.time_per_question_delay : 1000;
            this._timePerQuestionFired = false;
            this._timePerQuestionDelayFired = false;
        }

        P3.audio.playSound(["sfx_scroll_open_00", "sfx_scroll_open_01"]);
    }

    startTimerLoopSFX() {
        this.stopTimerLoopSFX();

        this._timerLoopSFX = P3.audio.playSound("sfx_question_timer_01", {loop: true});
    }

    stopTimerLoopSFX() {
        if (this._timerLoopSFX) {
            this._timerLoopSFX.stop();
            this._timerLoopSFX = null;
        }
    }

    animateCamera(correct, funca, funcb, scope) {
        const settings = common.gmi.getAllSettings();
        if (settings.motion) {
            this._cameraTweens.removeAll();

            const partyPosition = new PIXI.Point(-120, 20);
            const bossPosition = new PIXI.Point(120, -40);
            const centerPosition = new PIXI.Point(0, 0);

            let target = correct ? partyPosition : bossPosition;

            const a = new P3.utils.TWEEN.Tween(this._camera.position, this._cameraTweens)
                .to({x: target.x, y: target.y}, 420)
                .easing(P3.utils.TWEEN.Easing.Cubic.InOut)
                .onStart(() => {
                    new P3.utils.TWEEN.Tween(this._camera, this._cameraTweens)
                        .to({zoom: 1.2}, 420)
                        .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                        .start();
                })
                .onComplete(() => {
                    P3.utils.delayg(this._cameraTweens, 1, () => {
                        funca && funca.call(scope);
                    });
                });

            target = correct ? bossPosition : partyPosition;

            const b = new P3.utils.TWEEN.Tween(this._camera.position, this._cameraTweens)
                .to({x: target.x, y: target.y}, 340)
                .easing(P3.utils.TWEEN.Easing.Cubic.Out)
                .delay(600);

            const c = new P3.utils.TWEEN.Tween(this._camera.position, this._cameraTweens)
                .to({x: centerPosition.x, y: centerPosition.y}, 640)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .delay(400)
                .onStart(() => {
                    new P3.utils.TWEEN.Tween(this._camera, this._cameraTweens)
                        .to({zoom: 1}, 640)
                        .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                        .start();
                })
                .onComplete(() => {
                    funcb && funcb.call(scope);
                });

            a.chain(b);
            b.chain(c);
            a.start();
        } else {
            funca && funca.call(scope);
            funcb && funcb.call(scope);
        }
    }

    damageParty() {
        --this._partyHealth;

        const f = this._partyHealth / this._questionCount;
        this._partyHealthBar.health = f;

        this._partyHealth <= 0 && (this._running = false);

        const member = P3.utils.selectRandom(this._party);
        member.playDamageAnim();

        if (common.character.female) {
            P3.audio.playSound([
                "sfx_generic_guardian_damage_female_00",
                "sfx_generic_guardian_damage_female_01",
                "sfx_generic_guardian_damage_female_02"
            ]);
        } else {
            P3.audio.playSound([
                "sfx_generic_guardian_damage_male_00",
                "sfx_generic_guardian_damage_male_01",
                "sfx_generic_guardian_damage_male_02"
            ]);
        }

        // pet animates if its master does
        if (member === this.player) {
            this._pet && this._pet.playDamageAnim();
        }

        console.log("party health:", f * 100 + "%");
    }

    damageBoss() {
        --this._bossHealth;

        const f = this._bossHealth / this._questionCount;
        this._bossHealthBar.health = f;

        this._bossHealth <= 0 && (this._running = false);

        this._boss.playDamageAnim();
        this._boss.playDamageVO();
        this._boss.playDamageSound();

        console.log("boss health:", f * 100 + "%");
    }

    initParty(x = 0, y = 0) {
        const scale = 0.25;
        const positions = [
            new PIXI.Point(-70, -6),
            new PIXI.Point(-120, 6)
        ];

        this._party[0] = this.createGuardian(common.character.type);
        this._party[0].position.set(x, y);
        this._party[0].scale.set(scale);
        this._party[0].init(common.character.skin);
        this._gameLayer.addChildAt(this._party[0], this._gameLayer.getChildIndex(this._particleLayer));

        this._party[0].setEmitterParent(this._particleLayer);
        this._party[0].playIdleAnim();

        const skins = [common.character.type];
        let characters = P3.utils.objectToArray(P3.assets.json("characters").filter(x => skins.indexOf(x.skin) === -1));

        for (let i = 1; i < Math.min(2, this._partyCount) + 1; ++i) {
            const position = positions[i - 1];

            const t = P3.utils.selectRandom(characters);
            skins.push(t.skin);
            characters = characters.filter(x => skins.indexOf(x.skin) === -1);

            this._party[i] = this.createGuardian(t.type);
            this._party[i].position.set(x + position.x, y + position.y);
            this._party[i].scale.set(scale);
            this._party[i].init(t.skin);
            this._gameLayer.addChildAt(this._party[i], this.player.parent.getChildIndex(this.player));

            this._party[i].setEmitterParent(this._particleLayer);
            this._party[i].playIdleAnim();
        }

        // equip guardian
        const user = common.save.getUserData(common.userId);
        for (const i in user.equipment) {
            if (user.equipment.hasOwnProperty(i)) {
                const type = user.equipment[i];
                if (i !== "pet") {
                    this._party[0].setItem(i, type);
                } else if (type > 0) {
                    this._pet = this.createPet(type);
                    this._pet.position.set(this._party[0].x, this._party[0].y - 40);
                    this._pet.scale.set(scale);
                    this._pet.init();
                    this._gameLayer.addChild(this._pet);

                    this._pet.playIdleAnim();
                }
            }
        }
    }

    initBoss(x = 0, y = 0) {
        this._boss = this.createBoss(common.boss.type);
        this._boss.position.set(x, y);
        this._boss.visible = false;
        this._boss.init();
        this._gameLayer.addChildAt(this._boss, this._gameLayer.getChildIndex(this._particleLayer));

        this._boss.setEmitterParent(this._particleLayer);
    }

    createGuardian(type) {
        const golden = common.save.isWeeklyChallengeComplete(common.userId);
        switch (type) {
            default :
            case Guardian.TYPE_ELF : {
                return new GuardianElf(golden);
            }
            case Guardian.TYPE_ELF_FEMALE : {
                return new GuardianElfFemale(golden);
            }
            case Guardian.TYPE_KNIGHT : {
                return new GuardianKnight(golden);
            }
            case Guardian.TYPE_KNIGHT_FEMALE : {
                return new GuardianKnightFemale(golden);
            }
            case Guardian.TYPE_RANGER : {
                return new GuardianRanger(golden);
            }
            case Guardian.TYPE_RANGER_FEMALE : {
                return new GuardianRangerFemale(golden);
            }
            case Guardian.TYPE_WARRIOR : {
                return new GuardianWarrior(golden);
            }
            case Guardian.TYPE_WIZARD : {
                return new GuardianWizard(golden);
            }
            case Guardian.TYPE_WITCH : {
                return new GuardianWitch(golden);
            }
        }
    }

    createBoss(type) {
        switch (type) {
            default :
            case Boss.TYPE_DRAGON : {
                return new BossDragon();
            }
            case Boss.TYPE_SPIDER : {
                return new BossSpider();
            }
            case Boss.TYPE_HOBGOBLIN : {
                return new BossHobgoblin();
            }
            case Boss.TYPE_TROLL : {
                return new BossTroll();
            }
            case Boss.TYPE_TRAINING_TROLL : {
                return new BossTrainingTroll();
            }
            case Boss.TYPE_SPIRIT : {
                return new BossSpirit();
            }
            case Boss.TYPE_MAGE : {
                return new BossMage();
            }
            case Boss.TYPE_GOLDEN_DRAGON : {
                return new BossGoldenDragon();
            }
        }
    }

    createPet(type) {
        switch (type) {
            default :
            case Pet.TYPE_OWL : {
                return new PetOwl();
            }
            case Pet.TYPE_BAT : {
                return new PetBat();
            }
            case Pet.TYPE_DRAGON : {
                return new PetDragon();
            }
            case Pet.TYPE_RAVEN : {
                return new PetRaven();
            }
        }
    }

    createScene() {
        const bg = new PIXI.Sprite(P3.assets.texture(common.location.theme.bg));
        this._backgroundLayer.addChild(bg);

        const left = new PIXI.Sprite(P3.assets.texture(common.location.theme.left));
        left.position.set(0, P3.View.height);
        left.anchor.set(0, 1);
        this._midgroundLayer.addChild(left);

        const right = new PIXI.Sprite(P3.assets.texture(common.location.theme.right));
        right.position.set(common.STAGE_WIDTH, P3.View.height);
        right.anchor.set(1, 1);
        this._midgroundLayer.addChild(right);

        const fg = new PIXI.Sprite(P3.assets.texture(common.location.theme.fg));
        fg.position.set(0, P3.View.height);
        fg.anchor.set(0, 1);
        this._gameLayer.addChild(fg);
    }

    createUI() {
        this._partyHealthBar = new HealthBar();
        this._partyHealthBar.position.set(common.STAGE_WIDTH * 0.5 - 390, 360);
        this._gameLayer.addChild(this._partyHealthBar);

        this._bossHealthBar = new HealthBar();
        this._bossHealthBar.position.set(common.STAGE_WIDTH * 0.5 + 360, 360);
        this._gameLayer.addChild(this._bossHealthBar);

        this._questionHolder = new PIXI.Container();
        this._hudLayer.addChild(this._questionHolder);

        this._questionCounter = new QuestionCounter(this._questionCount);
        this._questionCounter.position.set(common.STAGE_WIDTH * 0.5, P3.View.height - 26);
        this._hudLayer.addChild(this._questionCounter);

        const time = common.config.game.time[common.difficulty.level];
        this._timer = new QuizTimer(time);
        this._timer.position.set(this._questionCounter.x + 220, P3.View.height - 38);
        this._timer.visible = common.location.timed;
        this._hudLayer.addChild(this._timer);

        this._xpPanel = new PIXI.Sprite(P3.assets.texture("ui_results_xp"));
        this._xpPanel.position.set(common.STAGE_WIDTH * 0.5, 200);
        this._xpPanel.anchor.set(0.5);
        this._hudLayer.addChild(this._xpPanel);

        const user = common.save.getUserData(common.userId);
        let xp = Math.round(user.totalXp + this._totalXp);
        let size = 36;
        if (xp > common.config.game.xp_cap) {
            xp = Math.round(common.config.game.xp_cap) + "+";
            size = 32;
        }

        this._xpPanel.label = new PIXI.extras.BitmapText(xp + "", {font: size + "px BBC Reith Sans", align: "center"});
        this._xpPanel.label.position.set(-2, 18);
        this._xpPanel.label.anchor.set(0.5);
        this._xpPanel.label.tint = 0x390307;
        this._xpPanel.addChild(this._xpPanel.label);
    }

    playMusic() {
        const f = this._questionIndex / this._questionCount;
        if (f < 0.6) {
            P3.audio.playMusic(this._defaultMusicName);
        } else {
            P3.audio.playMusic(this._dangerMusicName);
        }
    }

    playAmbienceSFX() {
        this.stopAmbienceSFX();
        this._ambienceAudio = P3.audio.playSound(common.location.audio.ambience, {loop: true});

        if (common.location.challenge)
        {
            this._challengeAmbienceAudio = P3.audio.playSound("sfx_ambience_crowd_roar_loop_00", {volume: 0, loop:true});
        }
    }

    stopAmbienceSFX() {
        if (this._ambienceAudio) {
            this._ambienceAudio.stop();
            this._ambienceAudio = null;
        }

        if (this._challengeAmbienceAudio)
        {
            this._challengeAmbienceAudio.stop();
            this._challengeAmbienceAudio = null;
        }
    }

    playRoarEffect()
    {
        if (this._challengeAmbienceTween)
        {
            this._challengeAmbienceTween.stop();
            this._challengeAmbienceTween = null;
        }

        const t = {value: 0};

        this._challengeAmbienceTween = new P3.utils.TWEEN.Tween(t, this._tweens)
            .to({value: 1}, 3000)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .repeat(1)
            .yoyo(true)
            .onUpdate(() =>
            {
                if (this._challengeAmbienceAudio)
                {
                    this._challengeAmbienceAudio.howl.volume(t.value);
                }
            })
            .start();
    }

    playGuardianPositiveVO() {
        P3.audio.playSound([
            "vo_guardian_pos_1",
            "vo_guardian_pos_2",
            "vo_guardian_pos_3",
            "vo_guardian_pos_4",
            "vo_guardian_pos_5",
            "vo_guardian_pos_6",
            "vo_guardian_pos_7",
            "vo_guardian_pos_8",
            "vo_guardian_pos_9"
        ]);
    }

    playGuardianNegativeVO() {
        P3.audio.playSound([
            "vo_guardian_neg_1",
            "vo_guardian_neg_2",
            "vo_guardian_neg_3",
            "vo_guardian_neg_4",
            "vo_guardian_neg_5",
            "vo_guardian_neg_6",
            "vo_guardian_neg_7",
            "vo_guardian_neg_8",
            "vo_guardian_neg_9"
        ]);
    }

    disableMotionFX() {
        for (let i = 0; i < this._party.length; ++i) {
            const party = this._party[i];
            party.playIdleAnim();
            party.update(1);
        }
        this._boss.playIdleAnim();
        this._boss.update(1);
    }

    onQuestionViewConfirm(view, correct) {
        if (!this._running) return;

        this._timePerQuestionFired = true;

        this._questionInput.showCorrectAnswer();
        this._questionInput.lock();

        this._answers.push(correct);
        this._questionCounter.setAnswer(correct);

        this.stopTimerLoopSFX();

        if (correct) {
            ++this._correctCount;
            this._totalXp += common.config.game.xp[common.difficulty.level] || common.config.game.xp[0];

            const user = common.save.getUserData(common.userId);
            let xp = Math.round(user.totalXp + this._totalXp);
            let size = 36;
            if (xp > common.config.game.xp_cap) {
                xp = Math.round(common.config.game.xp_cap) + "+";
                size = 32;
            }
            this._xpPanel.label.font.size = size;
            this._xpPanel.label.text = xp + "";

            P3.audio.playSound(["music_round_won"]);

            if (common.location.challenge)
            {
                this.playRoarEffect();
            }
        } else {
            P3.audio.playSound(["music_round_lost"]);
        }

        console.log("question:", (this._questionIndex + 1));

        P3.utils.delayg(this._tweens, 1, () => {
            this._questionView.visible = false;
            this._questionInput.visible = false;

            P3.audio.playSound("sfx_scroll_disappear_00");

            if (correct) {
                const member = P3.utils.selectRandom(this._party);
                member.playAttackAnim();

                // pet animates if its master does
                if (member === this.player) {
                    this._pet && this._pet.playAttackAnim();
                }

                this.animateCamera(correct, () => this.damageBoss(), () => {
                    next.call(this);

                    this.playGuardianPositiveVO();
                });

                this.unlockQuestionAchievement();

                console.log("potential xp", this._totalXp);
            } else {
                this._boss.playAttackAnim();

                this.animateCamera(correct, () => this.damageParty(), () => {
                    next.call(this);

                    this._boss.playAttackVO();
                });
            }
        });

        function next() {
            if (this._questionIndex++ < this._questions.length - 1) {
                this.initQuestion();
            } else {
                P3.utils.delayg(this._tweens, 1.2, () => this.end());
            }

            this._questionCounter.next();

            this.playMusic();
        }
    }

    onCalculatorButtonClick(button) {
        const user = common.save.getUserData(common.userId);
        user.showKeypad = button.toggle;
        common.save.saveGame();

        if (button.toggle) {
            // tracking
            common.gmi.sendStatsEvent("keypad", "true");
        }
    }

    unlockQuestionAchievement()
    {
        if (!common.location.challenge)
        {
            common.achievements.setProgress(Achievement.ANSWER_QUESTIONS_LEVEL1, this._correctCount / 5);
            if (this._correctCount >= 5)
            {
                common.achievements.unlock(Achievement.ANSWER_QUESTIONS_LEVEL1);
            }

            common.achievements.setProgress(Achievement.ANSWER_QUESTIONS_LEVEL2, this._correctCount / 10);
            if (this._correctCount >= 10)
            {
                common.achievements.unlock(Achievement.ANSWER_QUESTIONS_LEVEL2);
            }
        }
    }

    get player() {
        return this._party[0];
    }
}